import React, { useState, useEffect, useContext } from 'react';
import DataTable from 'react-data-table-component';
import './Responsive.css';
import CircularProgress from '@material-ui/core/CircularProgress';
import lodash from 'lodash';
import CustomMaterialPagination from './customPagination';
import TableTopHeader from './TableTopHeader';
import { StateExporterRm } from '../../containers/RMDashboard/RmDashboard';

import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import { setFiltersInfo, getFiltersInfo } from '../../common/utils/FiltersInfo';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

const Table = props => {
  const [filterText, setFilterText] = React.useState(
    props.StatusFilter ? props.StatusFilter : ''
  );
  const [searchText, setSearchText] = React.useState(
    props.Search ? props.Search : ''
  );
  const [userData, setUserData] = React.useState(props.data ? props.data : []);
  const [rowsPerPage, setRowsPerPage] = useState({ size: 10 });
  const [tableLoader, setTableLoader] = useState(true);
  const [fromDate, setFromDate] = useState('');
  const [toDate, setToDate] = useState('');
  const [sortName, setsortName] = useState('createdOn');
  const [sortDir, setSortDirection] = useState('desc');
  const [page, setPage] = useState('0');
  const [Rows, setRows] = useState('');

  const stateExporterRm = useContext(StateExporterRm);

  const { setFilterProductType = false } = stateExporterRm || false;

  useEffect(() => {
    props?.setFilterStatus?.(filterText);
  }, [filterText]);

  useEffect(() => {
    setTableLoader(false);
    setUserData(props.data);
    let filters = {
      startDate: props.startDate,
      endDate: props.endDate,
      rmId: props.rmId,
      bpUserId: props.bpUserId
    };
    if (getFiltersInfo()) {
      setFiltersInfo(Object.assign(getFiltersInfo(), filters));
    } else {
      setFiltersInfo(filters);
    }
  }, [props.data]);

  useEffect(() => {
    if (props.TableInfo) {
      setRowsPerPage(props.TableInfo);
    }
  }, [props.TableInfo]);

  useEffect(() => {
    setFromDate(props.startDate);
    setToDate(props.endDate);
  }, [props.startDate, props.endDate]);

  useEffect(() => {
    setTableLoader(props.tableLoading);
  }, [props.tableLoading]);

  useEffect(() => {
    setFilterText(props.StatusFilter);
  }, [props.StatusFilter]);

  useEffect(() => {
    setTableLoader(props.tableLoading);
  }, [props.Search]);
  const [resetPaginationToggle, setResetPaginationToggle] = React.useState(
    false
  );

  let filteredItems = userData;
  if (!props.serverPagination)
    !props.FilterGetsChanged || !props.onSerachChange
      ? (filteredItems = userData
          ? userData.filter(item => {
              if (!props.customeFilter) {
                let firstName = item.name.firstName
                  ? item.name.firstName + ' '
                  : '';
                let middleName = item.name.middleName
                  ? item.name.middleName + ' '
                  : '';
                let lastName = item.name.lastName
                  ? item.name.lastName + ' '
                  : '';
                return (
                  (filterText && filterText != 'All'
                    ? item[props.filterName] &&
                      item[props.filterName]
                        .toLowerCase()
                        .includes(filterText.toLowerCase())
                    : true) &&
                  (searchText && item[props.searchName]
                    ? item[props.searchName].toString().includes(searchText) ||
                      (firstName + middleName + lastName &&
                        (firstName + middleName + lastName)
                          .toString()
                          .toLowerCase()
                          .includes(searchText.toLowerCase()))
                    : true)
                );
              } else {
                if (props.customeFilterFunction) {
                  return props.customeFilterFunction();
                }
              }
            })
          : [])
      : null;

  const subHeaderComponentMemo = React.useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText('');
      }
      if (setFilterProductType) setFilterProductType('');
    };

    return (
      <TableTopHeader
        onFilter={(e, _) => {
          setFilterText(e);
          if (_) {
            let keys = Object.keys(_).filter(k => _[k]);
            if (setFilterProductType) setFilterProductType(keys[0]);
          } else if (setFilterProductType) setFilterProductType('');
        }}
        onClear={handleClear}
        filterText={filterText}
        onSearch={e => {
          setSearchText(e),
            props.searchUrl
              ? lodash.debounce(handleSearch, 200, { maxWait: 1000 })(e)
              : null;
        }}
        StatusOPtion={props.StatusOPtion ? props.StatusOPtion : []}
        total_data={
          props.serverPagination
            ? rowsPerPage.totalElements
              ? rowsPerPage.totalElements
              : 0
            : filteredItems.length
        }
        serchBarPlaceHolder={props.serchBarPlaceHolder}
        GetLeadStatus={props.GetLeadStatus}
        filterCaption={props.filterCaption ? props.filterCaption : ''}
        filterImage={props.filterImage ? props.filterImage : false}
        tableListbelongs={props.tableListbelongs ? props.tableListbelongs : ''}
        filterComponent={props.filterComponent}
        labelText={props.labelText}
        rm={props.rm}
        rmId={props.rmId}
        setRmId={props.setRmId}
        customHeaderComponent={
          props.customHeaderComponent ? props.customHeaderComponent : false
        }
        onSerachChange={props.onSerachChange ? props.onSerachChange : false}
        filterStyle={props.filterStyle}
        searchStyle={props.searchStyle}
        showNumberOfListStyle={props.showNumberOfListStyle}
        leftSideHeaderComoponent={props.leftSideHeaderComoponent}
        filterContanier={props.filterContanier}
        filterBlock={props.filterBlock}
        multiSelect={props.filterMultiSelect}
        filteredObject={props?.filteredObject}
      />
    );
  }, [
    filterText,
    resetPaginationToggle,
    rowsPerPage,
    filteredItems,
    props?.render
  ]);

  const ChangeSortImage = () => {
    let header_container = document.getElementsByClassName('sc-fzpans');
    for (let i = 0; i < header_container.length; i++) {
      header_container[i].innerHTML = '&#8595;';
    }
  };

  const handlePerRowsChange = async (perPage, page) => {
    if (props.CustomhandlePerRowsChange) {
      props.CustomhandlePerRowsChange(perPage, page);
    } else if (fromDate && toDate) {
      setRowsPerPage(perPage);
      setTableLoader(true);
      page = parseInt(page) - 1;
      setPage(page);

      const response = await props.serverPaginationUrl(
        page,
        perPage,
        fromDate ? fromDate : '',
        toDate ? toDate : '',
        sortName ? sortName : '',
        sortDir ? sortDir : '',
        filterText,
        props.rmId,
        props.bpUserId
      );
      setUserData(response.data);
      setRowsPerPage(response.dataPage);
      setTableLoader(false);
    }
  };

  const handlePageChange = async page => {
    if (props.CustomhandlePageChange) {
      props.CustomhandlePageChange(page);
    } else if (fromDate && toDate) {
      setTableLoader(true);
      page = parseInt(page) - 1;
      setPage(page);

      try {
        const response = await props.serverPaginationUrl(
          page,
          rowsPerPage.size,
          fromDate ? fromDate : '',
          toDate ? toDate : '',
          sortName ? sortName : '',
          sortDir ? sortDir : '',
          filterText,
          props.rmId,
          props.bpUserId
        );
        setTableLoader(false);
        setUserData(response.data);
        setTableLoader(false);
        setRowsPerPage(response.dataPage);
      } catch {}
    }
  };

  const handleSort = async (column, sortDirection) => {
    if (props.CustomhandleSort) {
      props.CustomhandleSort(column, sortDirection);
    } else {
      setTableLoader(true);
      setsortName(column.selector);
      setSortDirection(sortDirection);
      const response = await props.serverPaginationUrl(
        page,
        rowsPerPage.size,
        fromDate ? fromDate : '',
        toDate ? toDate : '',
        column.selector ? column.selector : '',
        sortDirection ? sortDirection : '',
        filterText,
        props.rmId,
        props.bpUserId
      );
      setUserData(response.data);
      setTableLoader(false);
      setRowsPerPage(response.dataPage);
      setTableLoader(false);
    }
  };
  const handleSearch = async e => {
    let searchby = e;
    if (props.CustomhandleSearch) {
      props.CustomhandleSearch(e);
    } else {
      setTableLoader(true);
      const response = await props.searchUrl(
        rowsPerPage.size,
        fromDate ? fromDate : '',
        toDate ? toDate : '',
        searchby ? searchby : '',
        props.rmId ? props.rmId : ''
      );
      setUserData(response.data);
      setTableLoader(false);
      setRowsPerPage(response.dataPage);
      setTableLoader(false);
    }
  };

  useEffect(() => {
    if (!props?.filterComponent) return;
    if (props.FilterGetsChanged) {
      props.FilterGetsChanged(filterText);
    } else if (fromDate && toDate) {
      async function fetchData() {
        setTableLoader(true);
        try {
          const response = await props.serverPaginationUrl(
            page,
            rowsPerPage.size,
            fromDate ? fromDate : '',
            toDate ? toDate : '',
            sortName ? sortName : '',
            sortDir ? sortDir : '',
            filterText,
            props.rmId,
            props.bpUserId
          );
          setTableLoader(false);
          setUserData(response.data);
          setTableLoader(false);
          setRowsPerPage(response.dataPage);
        } catch {}
      }
      if (props.serverPagination) {
        fetchData();
      }
    }
  }, [filterText]);

  useEffect(() => {
    ChangeSortImage();
  }, [props.columns]);

  useEffect(() => {
    setRows(props.rows);
    setRowsPerPage({ size: props.rows });
  }, [props.rows]);

  useEffect(() => {
    setPage(props.page);
  }, [props.page]);

  return (
    <>
      <div
        className={`w-12/12 px-5 mx-auto overflow-auto mt-5 rounded-md tableDiv`}
        style={{ minHeight: '350px' }}
      >
        <DataTable
          columns={props.columns}
          data={filteredItems}
          subHeader
          subHeaderComponent={subHeaderComponentMemo}
          persistTableHead
          progressPending={tableLoader}
          pagination={props?.noPagination ? false : true}
          paginationTotalRows={
            rowsPerPage.totalElements ? parseInt(rowsPerPage.totalElements) : 0
          }
          paginationServer={props.serverPagination ? true : false}
          onChangeRowsPerPage={
            props.serverPagination ? handlePerRowsChange : () => {}
          }
          onChangePage={props.serverPagination ? handlePageChange : () => {}}
          progressComponent={
            <div className="py-8">
              <CircularProgress />
            </div>
          }
          onSort={props.serverSort ? handleSort : () => {}}
          sortServer={props.serverSort ? true : false}
          paginationComponent={() => (
            <CustomMaterialPagination
              handlePageChange={handlePageChange}
              handlePerRowsChange={handlePerRowsChange}
              setRowsPerPage={setRowsPerPage}
              setPage={setPage}
              page={page}
              pageInfo={rowsPerPage}
              setRows={setRows}
              Rows={Rows}
            />
          )}
          sortIcon={<ArrowDownwardIcon />}
        />
      </div>
    </>
  );
};

export default withErrorHandler(Table);
